import { Navigate, useLocation } from "react-router-dom";
import { isAdminLogged } from "@/lib/auth";

export default function RequireAdmin({ children }: { children: React.ReactElement }) {
  const location = useLocation();
  if (!isAdminLogged()) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
